module.exports = __webpack_public_path__ + "static/media/add-button.f942efac.svg";